module.exports = __webpack_public_path__ + "img/teamMember3.61e5a453.webp";